const selectors_compare = {
    comparePageRemoves: '[data-compare-page-remove-which-product]',
    comparePageProducts: '[data-compare-header-product]',
    comparePageProductImages: '[data-compare-header-image]',
    comparePageProductTitles: '[data-compare-header-title]',
    comparePageProductPrices: '[data-compare-header-price]',
    comparePageProductVariants: '[data-variant-select-finish]',
    comparePageProductCtas: '[data-compare-header-cta]',
    comparePageProductRows: '[data-field-number]',
    comparePageProductFieldNames: '[data-product-field-name]',
    comparePageProductFieldValues: '[data-product-field-value]'
}

const subwooferLabels = [
    "Description",
    "Characteristics",
    "Driver Size",
    "Continuous (RMS) Power",
    "Peak Power",
    "Frequency Response ±3dB",
    "Cabinet Finish Options",
    "Subwoofer Dimensions (H x W x D)",
    "Weight",
    "Cabinet Configuration",
    "Port Size",
    "Useable Low Frequency Extension",
    "Max Low Frequency Output at 30Hz",
    "Inputs",
    "Outputs",
    "Standby Mode",
    "Low Pass Control",
    "Low Pass Slope",
    "Phase Control",
    "Parametric Equalizer",
    "Room Gain Compensation",
    "Variable Subwoofer Tuning",
    "SVS Auto EQ",
    "Grille Material",
    "5 Year Unconditional Warranty",
    "Lifetime Tech Support"
]

const speakerLabels = [
    "Description",
    "Characteristics",
    "Frequency Response +/-3dB",
    "Sensitivity",
    "Nominal Impedance",
    "Recommended power",
    "Speaker Finish Options",
    "Speaker Dimensions",
    "Weight",
    "Tweeter",
    "Midrange Driver",
    "Woofer",
    "Crossover Design",
    "Speaker Connection",
    "5 Year Unconditional Warranty",
    "Lifetime Tech Support"
]

// populate on page load
$(window).on('load', function() {
    populatePage();
})

$(document).ready(function() {
    populatePage();
})
$(document).ready(function() {

    $(selectors_compare.comparePageRemoves).on('click', (evt) => {
        var cookie = $(evt.currentTarget).data('compare-page-remove-product-cookie');
     

        var whichProduct = $(evt.currentTarget).data('compare-page-remove-which-product');
        var count = parseInt($('#comparePageCount').html());
        count -= 1;
        $('#comparePageCount').html(count);
        if (count == 0) {
            $('.pageCompare_comparison').addClass('hide');
            $('.pageCompare_empty').removeClass('hide');
        }
        setTimeout(() => {
            $.removeCookie(cookie, { path: '/' });
            window.location.reload();
        }, 1000);
        hideProduct(whichProduct);
        return false;
    })
});

function populatePage() {
    var product1Handle, product2Handle, product3Handle, productType;
    var count = 0;
    product1Handle = $.cookie('product_compare1');
    product2Handle = $.cookie('product_compare2');
    product3Handle = $.cookie('product_compare3');
    productType = $.cookie("product_type");

    $(".product_compare1").attr("aria-label" , "Remove" + " " + product1Handle)
    $(".product_compare2").attr("aria-label" , "Remove" + " " + product2Handle)
    $(".product_compare3").attr("aria-label" , "Remove" + " " + product3Handle)

    if (product1Handle == undefined) {
        hideProduct('product1')
    } else {
        fetchProduct(product1Handle, 'product1');
        count += 1;
    }
    if (product2Handle == undefined) {
        hideProduct('product2')
    } else {
        fetchProduct(product2Handle, 'product2');
        count += 1;
    }
    if (product3Handle == undefined) {
        hideProduct('product3')
    } else {
        fetchProduct(product3Handle, 'product3');
        count += 1;
    }
    if (count == 0) {
        $('.pageCompare_comparison').addClass('hide');
        $('.pageCompare_empty').removeClass('hide');
    }

    var countText = " items";
    if (count == 1) {
        countText = " item";
    }
    var countText = count.toString() + countText;
    $('#comparePageCount').html(countText);
}

function fetchProduct(productHandle, whichProduct) {
    var productData;
    var url = "/products/" + productHandle + "?view=metafields";
    $.ajax({
        url: url,
        type: 'GET',
        success: function(data) {
            var productData = $.parseJSON(data);
            updateCompareColumn(productData, whichProduct);
        }
    })
}





function updateCompareColumn(productData, whichProduct) {
    var price = "$" + (productData.product.price / 100.00).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
    var variantsHTML = '<ul>';
    var uniqueVariantTitles = new Set();

    productData.product.variants.forEach(function(variant) {
        var variantTitle = variant.title;
        var variantPrice = "$" + (variant.price / 100.00).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
        var colorSwatchName = variantTitle.toLowerCase().replace(/\s/g, '_') + '.png';
        var imageUrl_Bg = 'www.svsound.com/cdn/shop/files/' + colorSwatchName;

        if (!uniqueVariantTitles.has(variantTitle)) {
            variantsHTML += '<li><span id="variant-pricechange" class="variant-price-change" data-variant_price="' + variantPrice + '>' + variantTitle + '</span></li>';
            uniqueVariantTitles.add(variantTitle);
        }
    });

    variantsHTML += '</ul>';
    $(`${selectors_compare.comparePageProductImages}[data-compare-header-image="${whichProduct}"]`).attr('src', productData.product.featured_image)
    $(`${selectors_compare.comparePageProductTitles}[data-compare-header-title="${whichProduct}"]`).html(productData.product.title)
    $(`${selectors_compare.comparePageProductPrices}[data-compare-header-price="${whichProduct}"]`).html(price)
    $(`${selectors_compare.comparePageProductVariants}[data-variant-select-finish="${whichProduct}"]`).html(variantsHTML)
    $(`${selectors_compare.comparePageProductCtas}[data-compare-header-cta="${whichProduct}"]`).attr('href', 'https://www.svsound.com/products/' + productData.product.handle);
    var limit, extra, fieldName, fieldValue, name, value, productRow, nameField, valueField;
    if (productData.product.type == "Subwoofer") {
        limit = 26;
    } else if (productData.product.type == "Speaker") {
        limit = 16;
    }
    for (var i = 1; i <= limit; i++) {
        if (productData.product.type == "Subwoofer") {
            name = subwooferLabels[i - 1];
        } else if (productData.product.type == "Speaker") {
            name = speakerLabels[i - 1];
        }
        fieldValue = "field-" + i.toString();
        value = productData.metafields[fieldValue];
        productRow = $(`${selectors_compare.comparePageProductRows}[data-field-number="${i}"]`);
        nameField = $(`${selectors_compare.comparePageProductFieldNames}[data-product-field-name="${i}"]`);
        valueField = $(`${selectors_compare.comparePageProductFieldValues}[data-${whichProduct}-product-field-value="${i}"]`);
        productRow.removeClass('hide');
        $(`${selectors_compare.comparePageProducts}[data-compare-header-product="${whichProduct}"]`).removeClass('hide');
        $(`${selectors_compare.comparePageProducts}[data-compare-header-product="${whichProduct}"]`).parents('th').removeClass('hide');
        if (name != undefined) {
            nameField.html(name);
            nameField.parent().removeClass('invisible');
        }
        if (value != undefined) {
            valueField.html(value);
            valueField.removeClass('invisible');
        } else {
            valueField.html("-");
        }
    }
}

function hideProduct(whichProduct) {
    $(`${selectors_compare.comparePageProducts}[data-compare-header-product="${whichProduct}"]`).addClass('hide');
    $(`${selectors_compare.comparePageProducts}[data-compare-header-product="${whichProduct}"]`).parents('th').addClass('hide');
    for (var i = 1; i <= 25; i++) {
        $(`${selectors_compare.comparePageProductFieldValues}[data-${whichProduct}-product-field-value="${i}"]`).addClass('invisible');
    }
}

$(document).ready(function() {
    $('.productCompareBlock_product-icon,.compare-products-svg,.pageCompare_empty .basic-button').click(function() {
        var comparePopup = $('#shopify-section-compare-products-popup');
        if (comparePopup.is(':visible')) {
            comparePopup.slideUp();
        } else {
            comparePopup.slideDown();
        }
    });
});